import BluebirdPromise from 'bluebird';
import cns from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import {
    getManyCollections,
    getManyCompanies,
    getManyTeamsAdmin,
    pushCollectionToCompanyMembers
} from '../../../shared/actions';
import VerbSelect from '../../../shared/components/formComponents/inputs/VerbSelect';
import Page from '../../../shared/components/Page';
import PageContent from '../../../shared/components/PageContent';
import PageHeader from '../../../shared/components/PageHeader';
import VerbButton from '../../../shared/components/VerbButton';
import { makeGetObjectsFromStateById } from '../../../shared/selectors/index';

// { parentId: companyId, getRegistered: false, getAllMembers: true }
class PushCollectionContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCompanyId: null,
            selectedCollectionId: null,
            error: null,
            statusMessage: ''
        };
    }

    static propTypes = {
        getManyCollections: PropTypes.func.isRequired,
        getManyCompanies: PropTypes.func.isRequired,
        getManyTeamsAdmin: PropTypes.func.isRequired,
        pushCollectionToCompanyMembers: PropTypes.func.isRequired,
        companies: PropTypes.array.isRequired,
        loggedInUser: PropTypes.object
    };

    static contextType = RuntimeContext;

    componentDidMount() {
        const { getManyCompanies, loggedInUser } = this.props;
        getManyCompanies({ pathsContext: this.context.pathsWeb });
    }

    onChange = (stateKey, value) => {
        this.setState(() => ({ [stateKey]: value }));
    };

    onCompanyChange = (value) => {
        const { getManyTeamsAdmin, getManyCollections } = this.props;
        this.setState({ selectedCompanyId: value });
        const promises = [
            getManyCollections({ filterByCompany: true, companyId: value, pathsContext: this.context.pathsWeb }),
            getManyTeamsAdmin({
                parentId: value,
                getRegistered: false,
                getAllMembers: true,
                pathsContext: this.context.pathsWeb
            })
        ];
        return BluebirdPromise.all(promises).spread((collections, teams) => {
            const filteredCollections = collections.filter((collection) => collection.isActive && !collection.isLocked);
            this.setState({ teams: [{ _id: '', name: 'All Teams' }, ...teams], collections: filteredCollections });
        });
    };

    onSubmit = () => {
        const { pushCollectionToCompanyMembers } = this.props;
        const { selectedCollectionId, selectedCompanyId, selectedTeamId = '' } = this.state;
        if (!selectedCollectionId || !selectedCompanyId) {
            return null;
        }
        const body = {
            companyId: selectedCompanyId,
            collectionId: selectedCollectionId,
            teamId: selectedTeamId
        };
        return pushCollectionToCompanyMembers({ body, pathsContext: this.context.pathsWeb }).then(
            ({ status, error }) => {
                this.setState(() => ({ error, statusMessage: status }));
            }
        );
    };

    createSelects = (collections, companies, teams) => {
        const { selectedCollectionId, selectedCompanyId, selectedTeamId } = this.state;

        const selectAssetProps = {
            clearable: true,
            autoload: false,
            simpleValue: true,
            labelKey: 'name',
            valueKey: '_id',
            options: collections,
            value: selectedCollectionId,
            onChange: (value) => this.onChange('selectedCollectionId', value._id)
        };
        const selectCompanyProps = {
            clearable: true,
            autoload: false,
            simpleValue: true,
            labelKey: 'name',
            valueKey: '_id',
            options: companies,
            value: selectedCompanyId,
            onChange: (value) => this.onCompanyChange(value._id)
        };
        const selectTeamProps = {
            clearable: true,
            autoload: false,
            simpleValue: true,
            labelKey: 'name',
            valueKey: '_id',
            disabled: !teams || !teams.length,
            options: teams,
            value: selectedTeamId,
            onChange: (value) => this.onChange('selectedTeamId', value._id)
        };
        return (
            <div className={'row'}>
                <div className={'col-md-4'}>
                    <label>Select a Company</label>
                    <VerbSelect {...selectCompanyProps} />
                </div>
                <div className={'col-md-4'}>
                    <label>Select a Team</label>
                    <VerbSelect {...selectTeamProps} />
                </div>
                <div className={'col-md-4'}>
                    <label>Select a Collection</label>
                    <VerbSelect {...selectAssetProps} />
                </div>
            </div>
        );
    };

    _displayStatusMessage = () => {
        const { error, statusMessage } = this.state;

        if (error !== null) {
            return (
                <div
                    className={cns('col-12', { success: error === false, error: error === true })}
                    style={{ padding: '0' }}
                >
                    {statusMessage}
                </div>
            );
        }
        return null;
    };

    render() {
        const { companies } = this.props;
        const { teams, collections } = this.state;

        return (
            <Page className={'partnership-upload'}>
                <PageHeader
                    title={'Push Collection to Company members'}
                    className={'adminTableHeaderTabs adminPageHeader'}
                />
                <br />
                <PageContent>
                    <div className={'form-group'}>
                        {this.createSelects(collections, companies, teams)}
                        <br />
                        <VerbButton onClick={this.onSubmit} fontAwesomeIcon={'fa-arrow-alt-to-right'}>
                            PUSH COLLECTION
                        </VerbButton>
                    </div>
                    {this._displayStatusMessage()}
                </PageContent>
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const getCompaniesFromState = makeGetObjectsFromStateById('companies');
    const mapStateToProps = (state) => {
        const companies = getCompaniesFromState(state);
        const {
            auth: { loggedInUser }
        } = state;
        return {
            companies,
            loggedInUser
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getManyCollections: (params) => dispatch(getManyCollections(params)),
    pushCollectionToCompanyMembers: (params) => pushCollectionToCompanyMembers(params),
    getManyCompanies: (params) => dispatch(getManyCompanies(params)),
    getManyTeamsAdmin: (params) => dispatch(getManyTeamsAdmin(params))
});
export const PushCollectionContainerComponent = PushCollectionContainer;
export default connect(makeMapStateToProps, mapDispatchToProps)(PushCollectionContainer);
